module.exports = __webpack_public_path__ + "img/52-9116f5.png";